import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button, Checkbox, Tooltip, DatePicker, Tag, Dropdown, Menu, Drawer, Space, Spin, Divider } from 'antd'
import { ExclamationCircleFilled, QuestionCircleFilled, SyncOutlined } from '@ant-design/icons'
import FormImport from './FormImport'
import ResourcePoolList from '../../marketingResourcePool/components/ResourcePoolList'
import AddressList from './AddressList'
import { withTranslation } from 'react-i18next'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant'
import history from '../../../routes/history'
import alertMessage from '../../../utils/alertMessage'
import moment from 'moment'

const storage = window.localStorage
const { TextArea } = Input

@inject('emailListStore', 'marketingSmsManagementStore', 'accountStore', 'emailTemplateStore')
@observer
class FormModal extends Component {
  state = {
    regularlyTime: null,
    groupVal: '',
    isValid: '',
    httpVal: '',
    selectedTime: null,
    isDatePicker: 0,
    importModalVisible: false,
    detailsModalVisible: false,
    record: null,
    AddressVisible: false,
    hasEmailTemplate: false,
    testSendModalVisable: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const { emailListStore, marketingSmsManagementStore, title, location } = this.props
    const { detailsObj, searchItem } = emailListStore
    const { generateID } = marketingSmsManagementStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'marketGroupId': location?.state?.marketGroupId || searchItem?.marketGroupId,
        'taskName': detailsObj?.taskName,
        'expoResume': detailsObj?.expoResume,
        'tplIdList': detailsObj?.tplIdList[0],
        'sendDomain': detailsObj?.sendDomain,
        'sendAccountList': detailsObj?.sendAccountList,
        'sendFullName': detailsObj?.sendFullName,
        'sendReplyTo': detailsObj?.sendReplyTo,
        // "mailListIdList": detailsObj?.mailListIdList,
        'scheduleTime': detailsObj?.scheduleTime,
      })
      this.onAction(searchItem?.marketGroupId)
      this.getSender(searchItem?.marketGroupId, detailsObj?.sendDomain)
      this.setState({
        groupVal: searchItem?.marketGroupId,
        httpVal: detailsObj?.sendDomain
      })
    } else {
      this.formRef.current.setFieldsValue({
        marketGroupId: location?.state?.marketGroupId || undefined
      })
      if (location?.state?.marketGroupId) {
        this.onChangeGroup(location?.state?.marketGroupId)
      }
      emailListStore.onStatisticsAction({
        'taskGroupId': generateID,
      })
    }

  }

  onAction = (value) => {
    const { emailListStore } = this.props
    emailListStore.onGetTemplate({
      'marketGroupId': value
    })
    emailListStore.onGetHttp({
      'marketGroupId': value
    })
    emailListStore.onGetConcater({
      'marketGroupId': value
    })
    emailListStore.onExpoAction()

    //获取资源池的 下拉列表
    emailListStore.onGetResourcePool({
      configTypeList: ['3'],
      marketingGroupId: [value],
    })
  }

  getSender = (value, domain) => {
    const { emailListStore } = this.props
    emailListStore.onGetSender({
      'domain': domain,
      'marketGroupId': value
    })
  }

  handleOk = () => {
    const { emailListStore, marketingSmsManagementStore, handleCancel, type, title } = this.props
    const { detailsObj, handPhoneNum, filePhoneNum, resourcePhoneNum } = emailListStore
    const { generateID } = marketingSmsManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if ((handPhoneNum + filePhoneNum + resourcePhoneNum) > 0) {
        let params = {
          'id': title === 'edit' ? detailsObj?.id : null,
          'marketGroupId': fieldsValue?.marketGroupId,
          'taskName': fieldsValue?.taskName,
          'expoResume': fieldsValue?.expoResume,
          'tplIdList': [fieldsValue?.tplIdList],
          'sendDomain': fieldsValue?.sendDomain,
          'sendAccountList': fieldsValue?.sendAccountList,
          'sendFullName': fieldsValue?.sendFullName,
          'sendReplyTo': fieldsValue?.sendReplyTo,
          // "mailListIdList": fieldsValue?.mailListIdList,
          'isSchedule': this.state.regularlyTime ? 0 : 1, //是否定时发送 0是 1否
          'scheduleTime': fieldsValue?.scheduleTime ? moment(fieldsValue?.scheduleTime).format('YYYY-MM-DD HH:mm:ss') : null,
          'taskGroupId': generateID,
        }
        if (title === 'edit') {
          emailListStore.onEditJobAction({ ...params, id: detailsObj.id }, type, title).then(res => {
            if (res?.data?.code === 0) {
              this.formHandleCancel('', true)
            }
          })
        } else {
          emailListStore.onAddJobAction({ ...params }, type,).then(res => {
            if (res?.data?.code === 0) {
              this.formHandleCancel('', true)
            }
          })
        }
      } else {
        alertMessage.error('请输入发送邮箱!')
      }
    }).catch(() => { })
  }
  // 显示测试发送窗口
  handleShowTestSend = () => {
   
    this.formRef.current.validateFields().then(fieldsValue => {
      this.setState({ testSendModalVisable: true })
    }).catch(() => { })
  }
  // 测试发送
  handleTestSend = () => {
    const { emailListStore, marketingSmsManagementStore, accountStore, title } = this.props;
    const { accountInfos } = accountStore
    const { detailsObj } = emailListStore
    const { generateID } = marketingSmsManagementStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const receiver = this.formRef.current.getFieldValue("testEmailArea");
    if (receiver == undefined || receiver.length == 0) {
      alertMessage.error("请输入测试邮箱地址")
    } else {
      const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5\.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      const str = receiver.replace(/，/g, ',')
      const arr = str.split(',')
      const okArr = arr.filter(a => regEmail.test(a)) ?? []
      const failedArr = arr.filter(a => !regEmail.test(a)) ?? []
      if (failedArr.length > 0) {
        let error = "错误的邮箱地址：";

        for (var i = 0; i < failedArr.length; i++) {
          if (i == failedArr.length - 1) {
            error += failedArr[i]
          } else {
            error += failedArr[i] + ","
          }
        }
        error += " 请重新输入";
        alertMessage.error(error, 5);
      } else {
        if (okArr.length > 10) {
          alertMessage.error("当前测试邮件只允许10个以内的邮箱地址")
        } else {
          this.formRef.current.validateFields().then(fieldsValue => {

            let params = {
              'emailList': okArr,
              'expoResume': fieldsValue?.expoResume,
              'id': title === 'edit' ? detailsObj?.id : null,
              "isPowerUser": accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
              'marketGroupId': fieldsValue?.marketGroupId,
              'scheduleTime': fieldsValue?.scheduleTime ? moment(fieldsValue?.scheduleTime).format('YYYY-MM-DD HH:mm:ss') : null,
              'sendAccountList': fieldsValue?.sendAccountList,
              'sendDomain': fieldsValue?.sendDomain,
              'sendFullName': fieldsValue?.sendFullName,
              'sendReplyTo': fieldsValue?.sendReplyTo,
              'taskGroupId': generateID,

              'taskName': fieldsValue?.taskName,
              'tplIdList': [fieldsValue?.tplIdList],
              'isSchedule': this.state.regularlyTime ? 0 : 1, //是否定时发送 0是 1否
            }

            emailListStore.onSendTestEmail(params).then(res => this.setState({ testSendModalVisable: false }))
          })
        }
      }
    }
  }
  //关闭测试发送窗口
  handleCancelTestSend = () => {
    this.setState({ testSendModalVisable: false })
  }
  //刷新模板列表
  handleSearchTemplateList = () => {
    const { emailListStore } = this.props

    const marketGroupId = this.formRef.current.getFieldValue("marketGroupId")
    if (marketGroupId) {
      emailListStore.onGetTemplate({
        'marketGroupId': marketGroupId
      })
    }
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  // 定时时间 checkbox
  onChangeRegularlySend = (value) => {
    this.setState({
      regularlyTime: value.target.checked
    })
  }

  onChangeGroup = (value) => {
    this.setState({
      groupVal: value,
      regularlyTime: false,
      hasEmailTemplate: false
    })
    this.onAction(value)
    this.formRef.current.setFieldsValue({
      'taskName': '',
      'expoResume': undefined,
      'tplIdList': undefined,
      'sendDomain': undefined,
      'sendAccountList': undefined,
      'sendFullName': '',
      'sendReplyTo': '',
      'isSchedule': false,
      'scheduleTime': undefined,
      // "mailListIdList": undefined,
    })
  }

  onChangeHttp = (value) => {
    const { emailListStore } = this.props
    this.setState({
      httpVal: value
    })
    if (value !== 'all') {
      this.getSender(this.state.groupVal, value)
      this.formRef.current.setFieldsValue({
        'sendAccountList': undefined,
      })
    } else {
      emailListStore.onChangeSenderList([])
      this.formRef.current.setFieldsValue({
        'sendAccountList': ['all'],
      })
    }
  }

  tagRender = (props) => {
    const { label, value, closable, onClose } = props
    const onPreventMouseDown = (event) => {
      event.preventDefault()
      event.stopPropagation()
    }
    return (
      <Tag
        color={value}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3,
        }}
      >
        {label[1]?.props?.children} - {label[2]}
      </Tag>
    )
  }


  dropdownRender = (menu) => {
    return (<>{menu}
      <Divider
        style={{
          margin: '4px 0px',
        }}
      /><Button type="primary" shape="round" style={{ marginLeft: '5px' }} onClick={this.handleSearchTemplateList} >刷新</Button></>)
  }
  // 当前时间的10分钟之内不可以选择
  // 禁用今天之前的日期
  disabledDate = (current) => {
    return current && current < moment().startOf('day')
  }

  // 获取当前精确时间（到秒）
  getCurrentTime = () => moment().clone().subtract(1, 'hour')

  // 禁用时间规则（精确到秒）
  disabledTime = (current) => {
    if (!current) return {}

    const now = this.getCurrentTime()

    // 如果不是今天则不禁用
    if (!current.isSame(now, 'day')) {
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => []
      }
    }

    // 当前时间各维度值
    const currentHour = now.hour()
    const currentMinute = now.minute()
    const currentSecond = now.second()

    return {
      // 禁用小时
      disabledHours: () => [...Array(currentHour).keys()],

      // 禁用分钟
      disabledMinutes: (selectedHour) => {
        if (selectedHour === currentHour) {
          return [...Array(currentMinute).keys()]
        }
        return []
      },

      // 禁用秒
      disabledSeconds: (selectedHour, selectedMinute) => {
        if (selectedHour === currentHour && selectedMinute === currentMinute) {
          return [...Array(currentSecond).keys()]
        }
        return []
      }
    }
  }

  onOpenChange = (val) => {
    if (!val) {
      this.setState({
        isDatePicker: 0
      })
    }
  }
  // 处理日期选择变化
  handleChangeDatePicker = (date) => {
    if (!date) {
      this.setState({
        selectedTime: null
      })
      return
    }

    const now = moment()
    let newDate = date.clone()

    // 如果是今天
    if (date.isSame(now, 'day')) {
      const nowPlus10 = this.state.isDatePicker + 1 === 1 ? now.clone().subtract(1, 'hour') : now.clone()

      // 如果超过当天时间，自动跳转次日 00:00
      if (nowPlus10.isAfter(date.endOf('day'))) {
        newDate = date.clone().add(1, 'day').startOf('day')
      } else {
        newDate = nowPlus10
          .set('date', date.date())
          .set('month', date.month())
          .set('year', date.year())
      }
    } else {
      // 非今天日期重置为当天起始时间
      newDate = date.clone().startOf('day')
    }

    this.setState({
      selectedTime: newDate
    })
    this.formRef.current.setFieldsValue({
      'scheduleTime': newDate,
    })
  }

  // 点击按钮 详情
  importDetails = (e, type, isValid) => {
    this.setState({
      AddressVisible: true,
      sourceType: type,
      isValid: isValid,
    })
  }

  handleCancelAddressList = () => {
    this.setState({
      AddressVisible: false,
      sourceType: '',
      isValid: '',
    })
  }

  // phoneTextArea 发送手机号码文本框 修改
  onChangeHandEmail = (text) => {
    const value = text.target.value
    //较验手机号的正则表达式
    const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5\.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    const str = value.replace(/，/g, ',')
    const arr = str.split(',')
    const newArr = arr.filter(a => regEmail.test(a))
    if (newArr.length > 0) {
      this.addAddress(newArr)
    }
  }

  // 手动添加地址
  addAddress = (value) => {
    const { emailListStore, marketingSmsManagementStore, accountStore, type } = this.props
    const { searchItem } = emailListStore
    const { generateID } = marketingSmsManagementStore
    const { accountInfos } = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    // 待发送列表的 searchItem.marketGroupId 是 null（搜索条件里没带项目组），
    // 这里必须用当前弹窗里选中的项目组，否则后端 @NotBlank 会报 "marketGroupId must not be blank"
    const marketGroupId = this.formRef.current?.getFieldValue('marketGroupId') || this.state.groupVal || searchItem?.marketGroupId
    emailListStore.onAddAddressAction({
      'marketGroupId': marketGroupId,
      'taskGroupId': generateID,
      'address': value,
    }).then(res => {
      if (res?.data?.code === 0) {
        emailListStore.onAddressAction({
          'email': '',
          'taskGroupId': generateID,
          'isPowerUser': accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
          'page': 1,
          'size': PAGE_SIZE_DEFAULT
        })
        emailListStore.onStatisticsAction({
          'taskGroupId': generateID,
        })
        this.formRef.current.setFieldsValue({
          'phoneTextArea': undefined,
        })
      }
    })
  }

  // 点击按钮 文件导入
  handleImport = (record) => {
    this.setState({
      importModalVisible: true,
      sourceType: '2',
      record: record
    })
  }

  handleCancelImport = () => {
    this.setState({
      importModalVisible: false,
      sourceType: '',
      record: null
    })
  }

  // 点击按钮 资源池导入
  handlePoolImport = (e, record) => {
    this.setState({
      detailsModalVisible: true,
      sourceType: '3',
      record: record,
    })
  }

  handleCancelPoolImport = () => {
    this.setState({
      detailsModalVisible: false,
      sourceType: '',
      record: null
    })
  }

  createPool = () => {
    const { accountStore } = this.props
    history.push(`/resourcePool`)
    accountStore.setSeletedItem('resourcePool')
    accountStore.onMenuClick(['resourcePool'])
  }

  // 关闭 新建短信 窗口
  formHandleCancel = (e, status) => {
    const { emailListStore, marketingSmsManagementStore, handleCancel, location } = this.props
    const { generateID } = marketingSmsManagementStore
    if (!status) {
      emailListStore.onClearAddressAction({
        'taskGroupId': generateID,
      })
    }
    handleCancel()
    this.setState({
      regularlyTime: null,
      groupVal: '',
      httpVal: '',
      selectedTime: null,
      isDatePicker: 0,
      importModalVisible: false,
      detailsModalVisible: false,
      record: null,
      AddressVisible: false,
      testSendModalVisable: false
    })
    if (this.props?.location?.state?.taskType) {
      history.push(`/emailList`, {})
    }
  }

  getEmailTemplate = (e) => {
    this.setState({ hasEmailTemplate: !!e })
    const { emailTemplateStore } = this.props
    emailTemplateStore.onGetJobAction({
      id: e,
      marketGroupId: this.state?.groupVal
    })
  }

  render() {
    const { emailListStore, addModalVisible, handleCancel, title, t, emailTemplateStore } = this.props
    const {
      searchItem,
      groupList,
      templateList,
      httpList,
      senderList,
      concaterList,
      expoList,
      handPhoneNum,validHandPhoneNum,invalidHandPhoneNum, 
      filePhoneNum,validFilePhoneNum,invalidFilePhoneNum,
      validResourcePhoneNum,invalidResourcePhoneNum, resourcePhoneNum, 
      resourcePoolList,
      isTestSendFetching,
      isFetching,
      isFetchingAddress
    } = emailListStore
    const { hasEmailTemplate } = this.state
    //较验邮箱的正则表达式
    const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5\.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    return (
      <>
        <Modal
          title={t(`emailSend.onlineSend`)}
          closable={true}
          visible={addModalVisible}
          onCancel={e => this.formHandleCancel(e, false)}
          maskClosable={false}
          destroyOnClose={true}
          width={'70%'}
          centered
          footer={[
            <Button key="Test" type="primary" onClick={this.handleShowTestSend}>{t(`general.testSend`)}</Button>,
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.commitSend`)}</Button>,
            <Button key="Cancel" onClick={e => this.formHandleCancel(e, false)}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <div translate='no'>
          <div className="tips_box">
            <div className="f_red"><ExclamationCircleFilled /> 帮助和技巧:</div>
            <div>1、“指定跟踪统计链接域名”建议客户使用自己的独立的域名跟踪发送效果；</div>
            <div>2、平台在投递邮件过程中如果遇到收件方服务器阻塞（例如内容不好或发件人信誉度不良），平台可能会自动更换发件人投递以达到最优效果；</div>
            <div>3、如果您使用多发件人轮询发送模式，这种情况下推荐使用“回复地址”，这里输入一个常用的邮箱，这个邮箱会收到别人回复的邮件；</div>
          </div>
          <Spin spinning={isFetching || isFetchingAddress} >
            <Form ref={this.formRef} key="addMapping" layout="vertical">
              <Row gutter={[10, 10]}>
                <Col span={8}>
                  <Form.Item name="marketGroupId" label={t(`emailSend.marketingGroup`)}
                    rules={[{ required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.marketingGroup`)}` }]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    } onChange={this.onChangeGroup} disabled={title === 'edit'}>
                      {groupList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.groupName}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="taskName" label={t(`marketingManagement.taskName`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.taskName`)}`,
                  }]}>
                    <Input disabled={!this.state.groupVal} maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="expoResume" label={t(`marketingManagement.exhibitionSession`)}
                    rules={[{ required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.exhibitionSession`)}` }]}
                  >
                    <Select placeholder="仅用于统计" allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    } disabled={!this.state.groupVal}>
                      {expoList?.map(item => (<Select.Option key={item?.expoResume}
                        value={item?.expoResume}>{item?.expoCityName ? `${item?.expoResume}-${item?.expoCityName}` : `${item?.expoResume}`}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="tplIdList" label={t(`emailSend.selectTemplate`)}
                    rules={[{ required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.selectTemplate`)}` }]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch
                      dropdownRender={this.dropdownRender}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } disabled={!this.state.groupVal} tagRender={this.tagRender} onChange={this.getEmailTemplate}>
                      {templateList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{`[${item?.id}]`}<span
                        className="f_blue">{item?.name}</span>{`—${item?.subject?.name} `}<span
                          className="f_red">(约消耗{item?.emailCount}封)</span></Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="sendDomain" label={t(`emailSend.selectHttp`)}
                    rules={[{ required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.selectHttp`)}` }]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    } onChange={this.onChangeHttp} disabled={!this.state.groupVal}>
                      <Select.Option key="all" value="all">所有域名</Select.Option>
                      {httpList?.map(item => (<Select.Option key={item?.domain} value={item?.domain}>{item?.domain}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="sendAccountList" label={t(`emailSend.selectSender`)}
                    rules={[{ required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.selectSender`)}` }]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive"
                      maxTagTextLength={10} filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      } disabled={!this.state.groupVal}>
                      <Select.Option key="all" value="all">所有发件人邮箱</Select.Option>
                      {senderList?.map(item => (<Select.Option key={item?.mailbox} value={item?.mailbox}>{item?.mailbox}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="sendFullName" label={t(`emailSend.sendName`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`emailSend.sendName`)}`,
                  }]}>
                    <Input disabled={!this.state.groupVal} maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="sendReplyTo" label={t(`emailSend.replyAddress`)} rules={[{
                    required: false,
                    message: `${t(`general.pleaseEnter`)} 正确的 ${t(`emailSend.replyAddress`)}`,
                    pattern: new RegExp(regEmail)
                  }]}>
                    <Input disabled={!this.state.groupVal} maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                  </Form.Item>
                </Col>
                {/* <Col span={8}>
                <Form.Item name="mailListIdList" label={t(`emailSend.contact`)}
                  rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`emailSend.contact`)}`}]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch showArrow mode="multiple" maxTagCount="responsive" maxTagTextLength={10} filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } disabled={!this.state.groupVal}>
                    {concaterList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{`${item?.subject}(${item?.countReal}邮箱)`}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col> */}
                <Col span={3}>
                  <Form.Item name="isSchedule" label={t(`marketingManagement.regularlySend`)}>
                    <Checkbox onChange={this.onChangeRegularlySend}>
                      {`${t('marketingManagement.regularlyTime')} `}
                      <Tooltip title={t('marketingManagement.regularlySendTips')}>
                        <QuestionCircleFilled />
                      </Tooltip>
                    </Checkbox>
                  </Form.Item>
                </Col>
                {this.state.regularlyTime ? <Col span={5} style={{ marginTop: 30 }}><Form.Item name="scheduleTime"
                  rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.regularlySend`)}`,
                  }]}>
                  <DatePicker
                    showTime={{
                      format: 'HH:mm:ss'
                    }}
                    disabledTime={this.disabledTime}
                    disabledDate={this.disabledDate}
                    format="YYYY-MM-DD HH:mm:ss"
                    value={this.state.selectedTime}
                    onOpenChange={this.onOpenChange}
                    // onSelect={this.handleChangeDatePicker}
                    placeholder={t(`general.pleaseEnter`)}
                    style={{ width: '100%' }}
                    showNow={false}
                  />
                </Form.Item></Col> : null}
                <Col span={24}>
                  <div style={{ fontSize: 14 }}>发送邮箱</div>
                </Col>
                <Col span={24}>
                  <Row gutter={8}>
                    {this.state.groupVal ? <Col span={24}>
                      <div className="interSum sms" style={{ background: 'rgba(7, 58, 120, .03)', padding: 10}}>
                        <Row gutter={100}>
                          <Col flex="300px" style={{alignItems: 'center', borderRight: '1px solid #dddddd'}}>
                            <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>
                              {this.state.groupVal && validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e, null, '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum}</Button> : validHandPhoneNum + validFilePhoneNum +  validResourcePhoneNum}
                            </span><br />
                            <span style={{color: 'rgb(115, 209, 61)', fontWeight: 'bold'}}>{t(`marketingManagement.numberText7`)}</span>
                            <Tooltip
                              title="文件中一个地址占一行，每个邮件可以另外有10个变量；每个变量支持最长100个字符。 要导入的文件大小不能超过 20MB，大于 20MB 的文件请切割后分批导入。 地址导入时会进行地址合法性检测、有效性检测和重复性检测">
                              <QuestionCircleFilled />
                            </Tooltip>
                          </Col>
                          <Col flex="auto">
                            <Row gutter={16}>
                              <Col span={8}>
                                <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validHandPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'1', '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validHandPhoneNum}</Button> : validHandPhoneNum}</span>
                                <span style={{color: '#999999'}}> / </span>
                                <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidHandPhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'1', '1')} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidHandPhoneNum}</Button> : invalidHandPhoneNum}</span><br />
                                <span style={{color: '#666666'}}>{t(`marketingManagement.numberText1`)}</span>
                              </Col>
                              <Col span={8}>
                                <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validFilePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'2', '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validFilePhoneNum}</Button> : validFilePhoneNum}</span>
                                <span style={{color: '#999999'}}> / </span>
                                <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidFilePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'2', '1')} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidFilePhoneNum}</Button> : invalidFilePhoneNum}</span><br />
                                <span style={{color: '#666666'}}>{t(`marketingManagement.numberText2`)}</span>
                              </Col>
                              <Col span={8}>
                                <span style={{color: 'rgb(115, 209, 61)', fontSize: 20}}>{this.state.groupVal && validResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'3', '0')} style={{padding: 0, color: 'rgb(115, 209, 61)', fontSize: 20}}>{validResourcePhoneNum}</Button> : validResourcePhoneNum}</span>
                                <span style={{color: '#999999'}}> / </span>
                                <span style={{color: 'rgb(255, 77, 79)'}}>{this.state.groupVal && invalidResourcePhoneNum > 0 ? <Button type='link' onClick={e=>this.importDetails(e,'3', '1')} style={{padding: 0, color: 'rgb(255, 77, 79)'}}>{invalidResourcePhoneNum}</Button> : invalidResourcePhoneNum}</span><br />
                                <span style={{color: '#666666'}}>{t(`marketingManagement.numberText3`)}</span>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        {/* 输入邮件数：<span style={{ color: '#ff5200' }}>{handPhoneNum}</span> {t(`marketingManagement.total7`)}
                        {this.state.groupVal && handPhoneNum > 0 ?
                          <Button type="link" onClick={e => this.importDetails(e, '1')} style={{ padding: '4px' }}>详情</Button> : null}
                        ，文件导入邮件数：
                        <span style={{ color: '#ff5200' }}>{filePhoneNum}</span> {t(`marketingManagement.total7`)}
                        {this.state.groupVal && filePhoneNum > 0 ?
                          <Button type="link" onClick={e => this.importDetails(e, '2')} style={{ padding: '4px' }}>详情</Button> : null}
                        ，资源池导入邮件数：
                        <span style={{ color: '#ff5200' }}>{resourcePhoneNum}</span>{t(`marketingManagement.total7`)}
                        {this.state.groupVal && resourcePhoneNum > 0 ?
                          <Button type="link" onClick={e => this.importDetails(e, '3')} style={{ padding: '4px' }}>详情</Button> : null}
                        ，有效邮件数共
                        <span style={{ color: '#ff5200' }}>{allNum}</span>{t(`marketingManagement.total7`)} */}
                      </div>
                    </Col> : null}
                    <Col span={24} className="phoneTextArea">
                      <Form.Item name="phoneTextArea" style={{ marginBottom: 0 }}>
                        <TextArea onPressEnter={this.onChangeHandEmail} disabled={!this.state.groupVal} rows={3} placeholder="请输入请输入正确的邮箱，多个邮箱使用逗号分隔，按回车键确认正确的邮箱"
                          style={{ width: '100%' }} />
                      </Form.Item>

                    </Col>
                    <Col span={24}>
                      <div className='f_red' style={{ float: 'left', paddingLeft: '10px', paddingTop: '10px' }}><ExclamationCircleFilled /> 请输入正确的邮箱，多个邮箱使用逗号分隔，按回车键确认正确的邮箱</div>
                      <div className="shortLink" style={{ textAlign: 'right' }}>
                        <Button disabled={!this.state.groupVal} type="primary" onClick={e => this.handleImport(e, '2')}
                          style={{ marginRight: 10 }}>{t(`marketingManagement.importFile`)}</Button>
                        <Dropdown overlay={resourcePoolList.length > 0 ? (<Menu>
                          {resourcePoolList?.map((b, i) => <Menu.Item key={i}><a
                            onClick={e => this.handlePoolImport(e, b)}>{b?.resourcePoolName}</a></Menu.Item>)}
                        </Menu>) : (<div style={{ padding: '0 20px', backgroundColor: '#cfdbe6' }}>
                          前往<Button type="link" onClick={this.createPool} style={{ padding: '4px 5px' }}>{t(`menu.resourcePool`)}</Button>创建
                        </div>)} placement="bottomLeft" disabled={!this.state.groupVal}>
                          <Button disabled={!this.state.groupVal} type="primary"
                            onClick={e => e.preventDefault()}>{t(`marketingManagement.importResourcePool`)}</Button>
                        </Dropdown>
                      </div>
                    </Col>
                    {/* <Col span={24}>
                      <div className='tips_box'>
                        <div><ExclamationCircleFilled /> 一个地址占一行，格式如上，之间用分号“；”隔开。姓名, 性别, 生日, 手机, 地区, 变量1至10, 每个变量支持最长100个字符。</div>
                      </div>
                    </Col> */}
                  </Row>
                </Col>
                {
                  hasEmailTemplate && <div style={{ marginTop: '20px' }} dangerouslySetInnerHTML={{ __html: emailTemplateStore.detailsObj?.content }} />
                }
              </Row>
              <Drawer
                title="测试发送"
                autoFocus={true}
                destroyOnClose={true}
                placement="top"
                closable={true}
                onClose={this.handleCancelTestSend}
                visible={this.state.testSendModalVisable}
                size='small'
                style={{ padding: '0px', overflow: 'hidden' }}
                extra={
                  <Space>
                    <Button type="primary" shape="round" loading={isTestSendFetching} onClick={this.handleTestSend}>{t('general.testSend')}</Button>
                    <Button shape="round" onClick={this.handleCancelTestSend}>{t('general.close')}</Button>
                  </Space>
                }
              >
                <Spin spinning={isTestSendFetching}>
                  <Form.Item name="testEmailArea" label="测试邮箱地址" preserve={true} style={{ marginBottom: 0 }}>
                    <TextArea rows={5} allowClear={true} placeholder="请输入正确的邮箱，多个邮箱使用逗号分隔，测试邮箱最多输入10个邮箱地址"
                      style={{ width: '95%' }} />
                  </Form.Item>
                  <Form.Item name="testEmailAreaNotice" style={{ marginBottom: 0 }}>
                    <div className='f_red' style={{ marginLeft: '100px' }}><ExclamationCircleFilled /> 请输入正确的邮箱，多个邮箱使用逗号分隔，测试邮箱最多输入10个邮箱地址</div>
                  </Form.Item>
                </Spin>
              </Drawer>
            </Form>
          </Spin>
          </div>
        </Modal>

        {this.state.importModalVisible ? <FormImport
          handleCancel={this.handleCancelImport}
          importModalVisible={this.state.importModalVisible}
          record={this.state.record}
          marketGroupId={this.state.groupVal}
        /> : null}
        {this.state.detailsModalVisible ? <ResourcePoolList
          handleCancel={this.handleCancelPoolImport}
          addModalVisible={this.state.detailsModalVisible}
          record={this.state.record}
          marketGroupId={this.state.groupVal}
          isSelect={true}
          type="3"
        /> : null}
        {this.state.AddressVisible ?
          <AddressList
            handleCancel={this.handleCancelAddressList}
            addModalVisible={this.state.AddressVisible}
            sourceType={this.state.sourceType}
            isValid={this.state.isValid}
          />
          : null}
      </>
    )
  }
}

export default withTranslation()(FormModal)
